import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { TextInputFormElement } from './TextInputFormElement';

type ResultsPerQueryFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & { path: string };

export const ResultsPerQueryFormElement = ({ path }: ResultsPerQueryFormElementProps) => {
  const { setFieldValue } = useFormikContext();

  const transformInput = useCallback((val) => {
    const splitVal = val
      .split(',')
      .filter((v: unknown) => v === '' || !Number.isNaN(v))
      .map((v: string) => (v === '' ? '' : Number.parseFloat(v)));
    if (splitVal.includes('')) {
      setFieldValue('errorDetails', 'Invalid number in array.');
      setFieldValue('errorDescription', 'Please check your values.');
    } else {
      setFieldValue('errorDetails', undefined);
      setFieldValue('errorDescription', undefined);
    }
    return splitVal;
  }, []);

  const transformValue = useCallback((val) => {
    return Array.isArray(val) ? val.join(',') : val;
  }, []);

  return <TextInputFormElement path={path} style={{ minWidth: '100%' }} transformInput={transformInput} transformValue={transformValue} />;
};
